import React from 'react';
import './footer.css'
import logo from '../../../assets/logo.svg'
import Quicklink from '../common/quicklink';
import Socials from '../common/socials';
import face from '../../../assets/faceIcon.svg'
import twi from '../../../assets/twittericon.svg'
import inn from '../../../assets//inIcon.svg'
import insta from '../../../assets/instaIcon.svg'
const Footer = () => {
    return ( <>
    <footer>
        <div className='footerparent'>
            <div className='footerchild1'>
                <div className='f1'>
                    <div className="logo">
                        <img src={logo} alt="" />
                    </div>
                    <div className='f2'>
                        <h2 className='ftitle'>
                            Egypt's <span className='fspan'> Trusted</span> Real Estate
                             Partner
                        </h2>
                        <p className='footerp'>Designed for Elevated Living. We specialize in connecting investors and homeowners with high-value properties that combine architectural integrity, strategic location, and long-term growth potential.</p>
                    </div>
                </div>
                <div className='f3'>
                        <h2 className='pagestext'>Pages</h2>
                        <div className='quicklinksdiv'>
                            <Quicklink 
                            qlink="Home"
                            />
                            <Quicklink 
                            qlink="About"
                            />
                            <Quicklink
                            qlink="Contact"
                            />
                        </div>
                        <div className='connectdiv'>
                            <h2 className='pagestext'>Connect with us</h2>
                            <div className='socialmediadiv'>
                                <Socials 
                                socialsicon={face}
                                />
                                 <Socials 
                                socialsicon={twi}
                                />
                                 <Socials 
                                socialsicon={inn}
                                />
                                 <Socials 
                                socialsicon={insta}
                                />

                            </div>
                        </div>
                    
                </div>
                
            </div>
            <div className='footerline'></div>
            <h2 className='copyright'>Rights Reserved © EGYSTATES</h2>
        </div>
    </footer>
    </> );
}
 
export default Footer;